import { systemCode, xs_isMobile, xs_languageCode } from "../..";
import { getBaseURL } from "./getBaseURL";
import { getCheckbetPage } from "./getCheckbetPage";
import { getConfiguration } from "./configuration";
import { restoreURL } from "./restoreURL";

export function getCheckbetUrl(ticketId) {
    const conf = getConfiguration();

    let ticketUrl = '';
    if (conf.xspu && conf.xspu.chb) {
        ticketUrl = conf.xspu.chb.replaceAll('{{TICKET}}', ticketId);
        ticketUrl = ticketUrl.replaceAll('{{SYSTEM_CODE}}', systemCode);
        ticketUrl = ticketUrl.replaceAll('{{LANG}}', xs_languageCode);
        ticketUrl = restoreURL(ticketUrl);
    } else {
        const baseURL = getBaseURL();
        const checkbetPage = getCheckbetPage(xs_isMobile);
        // always in mobile version, 'cause it is full resposive
        ticketUrl = `${baseURL.replace('xsport_desktop', 'xsport_mobile')}${checkbetPage}?ticket=${ticketId}&system_code=${systemCode}&language=${xs_languageCode}`;
    }

    return ticketUrl;
}
